import { makeStyles } from "@material-ui/core";

const styles = makeStyles((theme) => {
  // required because we need to style the element inside the table and the one created by react portal
  const tableRow = {
    height: 52,
    background: theme.hv.palette.atmosphere.atmo1,
    "&:hover": {
      outline: `solid 1px ${theme.hv.palette.atmosphere.atmo4}`,
    },
    "&$tableRowDragging": {
      background: theme.hv.palette.atmosphere.atmo3,
      outline: `solid 1px ${theme.hv.palette.atmosphere.atmo4}`,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      boxShadow: theme.hv.shadows[1],
    },
  };

  return {
    tableContainer: {
      "& table$table": {},
    },
    table: {
      tableLayout: "fixed",
    },
    separator: {
      height: 10,
    },
    tableHead: {
      "& :first-child > $tableHeader": {
        borderTop: "none",
      },
      "& tr$tableRow": {
        height: 32,
        background: "none",
        "&:hover": {
          outline: "none",
        },
      },
    },
    tableHeader: {
      height: 32,
      border: "none",
      background: "none",
    },
    tableBody: {
      "& tr$tableRow": tableRow,
    },
    tableRow,
    tableRowSelected: {
      outline: `solid 1px ${theme.hv.palette.accent.acce1}`,
      "table$table &:hover": {
        outline: `solid 1px ${theme.hv.palette.accent.acce1}`,
      },
    },
    tableRowDragging: {},
    tableRowInvalid: {
      outline: `solid 1px ${theme.hv.palette.semantic.sema4}`,
      "table$table &:hover": {
        outline: `solid 1px ${theme.hv.palette.semantic.sema4}`,
      },
    },
    tableCell: {
      border: "none",
    },
    tableCellCheckbox: {
      borderRight: `solid 2px ${theme.hv.palette.atmosphere.atmo2}`,
    },
    tableCellAction: {
      borderLeft: `solid 2px ${theme.hv.palette.atmosphere.atmo2}`,
      padding: 10,
      width: 96,
      maxWidth: 96,
    },
    noData: {
      padding: 32,
    },
  };
});

export default styles;
